import { Fragment, useState } from "react";
import ImageRowItem from "../../ImageRowItem";

import { getLabel } from "../../../hooks/use-labels";
import { preparePaystackProps } from "../payment-process-utils";
import CheckoutPrompt from "../components/CheckoutPrompt";

import PayStackImage from "../assets/add-payment.svg";
import ResizeWrapper from "../../ResizeWrapper";

const PaystackProcessor = (props) => {
  const [prompt, showPrompt] = useState(false);

  const togglePrompt = () => {
    if (prompt) {
      showPrompt(false);
      setTimeout(() => showPrompt(true), 100);
    } else {
      showPrompt(true);
    }
  };

  const getPaystackProps = () => {
    const details = {
      apiKey: "data",
      referenceKey: "reference",
      checkoutUrl: "/payments/paystack",
      paymentStatusURL: "/payments/paystack/",
      authorizationURLKey: "authorization_url",
      hidePrompt: () => showPrompt(false),
      checkoutAPIProps: preparePaystackProps(props),
      onPaymentFailure: props.onPaymentFailure,
      onPaymentSuccessful: props.onPaymentSuccessful,
    };

    return details;
  };

  return (
    <ResizeWrapper
      render={(resizeWidth) => (
        <Fragment>
          <div className="method-item pointer" onClick={togglePrompt}>
            <ImageRowItem
              imageSrc={PayStackImage}
              title={getLabel("choosePaymentMethodLabel")}
              titleClass={`${
                resizeWidth > 575
                  ? "font-18-regular-500-lh-22"
                  : "font-16-regular-500-lh-22"
              }`}
            />

            {prompt && <CheckoutPrompt {...getPaystackProps()} />}
          </div>
        </Fragment>
      )}
    />
  );
};

export default PaystackProcessor;
